import classNames from 'classnames';

export interface IToggleIconProps {
    customOpenIcon?: string;
    customCloseIcon?: string;
    disabled?: boolean;
    isOpen: boolean;
    onClick?: (isOpen: boolean) => void;
}

export function ToggleIcon(props: IToggleIconProps) {
    const handleMinusClick = () => {
        if (props.onClick && !props.disabled) props.onClick(false);
    };

    const handlePlusClick = () => {
        if (props.onClick && !props.disabled) props.onClick(true);
    };

    const disabledStyle = {
        opacity: props.disabled ? 0.5 : 1,
        cursor: props.disabled ? 'default' : 'pointer',
    };

    return (
        <>
            {props.isOpen ? (
                <i
                    className={classNames('far color-black', {
                        'fa-minus': !props.customOpenIcon,
                        [props.customOpenIcon ?? '']: !!props.customOpenIcon,
                    })}
                    style={disabledStyle}
                    onClick={handlePlusClick}
                />
            ) : (
                <i
                    className={classNames('far color-black', {
                        'fa-plus': !props.customCloseIcon,
                        [props.customCloseIcon ?? '']: !!props.customCloseIcon,
                    })}
                    style={disabledStyle}
                    onClick={handleMinusClick}
                />
            )}
        </>
    );
}
